import { render } from "./AccountQuestion.vue?vue&type=template&id=6784c7bb"
import script from "./AccountQuestion.vue?vue&type=script&lang=js"
export * from "./AccountQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__